export class ContactFormBase {
    communityId: string;
    senderName: string;
    email: string;
    question: string;
    message: string;
}
